var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.94179 1.94179C3.1851 0.698483 4.87139 0 6.62969 0C8.38799 0 10.0743 0.698483 11.3176 1.94179C12.5609 3.1851 13.2594 4.87139 13.2594 6.62969C13.2594 8.38799 12.5609 10.0743 11.3176 11.3176C10.0743 12.5609 8.38799 13.2594 6.62969 13.2594C4.87139 13.2594 3.1851 12.5609 1.94179 11.3176C0.698483 10.0743 0 8.38799 0 6.62969C0 4.87139 0.698483 3.1851 1.94179 1.94179ZM6.62969 1.90452C5.3765 1.90452 4.17463 2.40235 3.28849 3.28849C2.40235 4.17463 1.90452 5.3765 1.90452 6.62969C1.90452 7.88288 2.40235 9.08474 3.28849 9.97088C4.17463 10.857 5.3765 11.3549 6.62969 11.3549C7.88288 11.3549 9.08475 10.857 9.97089 9.97088C10.857 9.08474 11.3549 7.88288 11.3549 6.62969C11.3549 5.3765 10.857 4.17463 9.97089 3.28849C9.08475 2.40235 7.88288 1.90452 6.62969 1.90452Z",
    fill: "#4A4A68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97037 9.97027C10.3423 9.59841 10.9452 9.59846 11.3171 9.97037L15.7203 14.3742C16.0922 14.7461 16.0921 15.3491 15.7202 15.7209C15.3483 16.0928 14.7454 16.0928 14.3735 15.7208L9.97027 11.317C9.59841 10.9451 9.59846 10.3421 9.97037 9.97027Z",
    fill: "#4A4A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.74cf321ebbf481e4256e2c7e67812106.svg";
export { ForwardRef as ReactComponent };